const navigation = document.querySelector('.footerColumn--navigation');
const menuLists = navigation
  ? [...navigation.querySelectorAll('ul:not(.socialButtons)')]
  : [];
const [mainMenu, footerMenu] = menuLists;
const accessoiresItem = [...(mainMenu?.querySelectorAll(':scope > li > a') || [])]
  .find((link) => link.textContent.trim().toLowerCase() === 'accessoires')
  ?.closest('li');
const hoofdkussenItem = [...(footerMenu?.querySelectorAll(':scope > li > a') || [])]
  .find((link) => link.pathname.endsWith('/accessoires/ergonomische-hoofdkussens'))
  ?.closest('li');

if (mainMenu && accessoiresItem && hoofdkussenItem) {
  mainMenu.insertBefore(hoofdkussenItem, accessoiresItem);
  hoofdkussenItem
    .querySelectorAll(':scope > a')
    .forEach((link) => !link.textContent.trim() && link.remove());
  accessoiresItem.remove();
}

menuLists.forEach((menuList) => {
  menuList
    .querySelectorAll(':scope > li')
    .forEach((item) => !item.textContent.trim() && !item.querySelector('a') && item.remove());
});
